export const QUALIFIER_LIMITS = {
  MAX_ITEM_COUNT: 1000,
  MAX_ITEM_LENGTH: 255,
  MAX_VALUE_SIZE_BYTES: 102400,
};

const MOJIBAKE_REGEX = /Ã[-ÿ]/;

/**
 * Validates filter list items for count and length limits.
 * Duplicates are now auto-deduplicated before reaching this function (EN-21586).
 *
 * @param {Array} existingItems - Items already in the filter
 * @param {Array<string>} newItems - New items being added
 * @returns {{valid: boolean, message?: string}}
 */
export function validateItems(existingItems, newItems) {
  // Note: Duplicate checking removed - deduplication happens upstream in the component
  const totalCount = existingItems.length + newItems.length;
  if (totalCount > QUALIFIER_LIMITS.MAX_ITEM_COUNT) {
    return {
      valid: false,
      message: `Cannot exceed ${QUALIFIER_LIMITS.MAX_ITEM_COUNT} items per filter. Current: ${existingItems.length}, attempting to add: ${newItems.length}.`,
    };
  }

  for (const item of newItems) {
    if (item.length > QUALIFIER_LIMITS.MAX_ITEM_LENGTH) {
      return {
        valid: false,
        message: `Item exceeds maximum length of ${QUALIFIER_LIMITS.MAX_ITEM_LENGTH} characters: "${item.substring(0, 50)}..."`,
      };
    }
    if (MOJIBAKE_REGEX.test(item)) {
      return {
        valid: false,
        message: "Corrupted text detected. Please re-enter the value without special character encoding issues.",
      };
    }
  }

  return { valid: true };
}

export function validateTotalSize(value) {
  if (!value) return { valid: true };
  const sizeBytes = new Blob([value]).size;
  if (sizeBytes > QUALIFIER_LIMITS.MAX_VALUE_SIZE_BYTES) {
    return {
      valid: false,
      message: `Filter value exceeds maximum size of 100KB (current: ${Math.round(sizeBytes / 1024)}KB).`,
    };
  }
  return { valid: true };
}
